import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import GroupDashboardScreen from './screens/GroupDashboardScreen';
import InvestorDashboardScreen from './screens/InvestorDashboardScreen';
import LandlordDashboardScreen from './screens/LandlordDashboardScreen';
import SaleDashboardScreen from './screens/SaleDashboardScreen';
import { useSelector } from 'react-redux';
import CoinvestorDashboardScreen from './screens/CoinvestorDashboardScreen';
import VoucherPartnerDashboardScreen from './screens/VoucherPartnerDashboardScreen';

AgencyDashboard.propTypes = {};

function AgencyDashboard(props) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const agencyId = user?.agencyId;

  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="sale" element={<SaleDashboardScreen agencyId={agencyId} />} />
          <Route path="investor" element={<InvestorDashboardScreen agencyId={agencyId} />} />
          <Route path="coinvestor" element={<CoinvestorDashboardScreen agencyId={agencyId} />} />
          <Route path="group" element={<GroupDashboardScreen agencyId={agencyId} />} />
          <Route path="landlord" element={<LandlordDashboardScreen agencyId={agencyId} />} />
          <Route path="voucher-partner" element={<VoucherPartnerDashboardScreen agencyId={agencyId} />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default AgencyDashboard;
